import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const rubricsMenuSkeletons: TSkeletons = Array(5).fill({
  width: null,
  height: null,
  className: 'rubrics-menu-item-loader',
})
